/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode & decode Base64`)
};

const es_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica y decodifica Base64`)
};

const de_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 kodieren und dekodieren`)
};

const nl_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 coderen & decoderen`)
};

const fr_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coder et décoder Base64`)
};

const it_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica e decodifica Base64`)
};

const pt_br2_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar e decodificar Base64`)
};

const pt_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar e descodificar Base64`)
};

const ja_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64をエンコード & デコード`)
};

const zh_b64_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码和解码 Base64`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_nav_main_desc", locale)
	if (locale === "en") return en_b64_nav_main_desc(inputs)
	if (locale === "es") return es_b64_nav_main_desc(inputs)
	if (locale === "de") return de_b64_nav_main_desc(inputs)
	if (locale === "nl") return nl_b64_nav_main_desc(inputs)
	if (locale === "fr") return fr_b64_nav_main_desc(inputs)
	if (locale === "it") return it_b64_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_b64_nav_main_desc(inputs)
	if (locale === "pt") return pt_b64_nav_main_desc(inputs)
	if (locale === "ja") return ja_b64_nav_main_desc(inputs)
	return zh_b64_nav_main_desc(inputs)
};